const addNewRelicPageAction = (actionName, actionObject) => {
  try {
    if (window.newrelic) {
      window.newrelic.addPageAction(actionName, actionObject);
    }
  } catch (e) {
    console.log('Error calling newRelic.addPageAction', actionName, actionObject); // eslint-disable-line no-console
  }
};

export default addNewRelicPageAction;